import React from 'react'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

const PREFIX = 'Home'
const classes = {
  container: `${PREFIX}-container`,
}
const Container = styled('div')({
  [`&.${classes.container}`]: {
    position: 'absolute',
    top: '0px',
    bottom: '0px',
    right: '0px',
    left: '0px',
    marginTop: '53px',
    padding: '1em',
  },
})

export default function Home() {
  return (
    <Container className={classes.container}>
      <Typography variant="h4" gutterBottom>
        Arup Vehicle Dynamics Assessment (VDA) Tool
      </Typography>
      <Typography variant="body1" gutterBottom>
        Welcome! To use the VDA tool follow these steps:
      </Typography>
      <ul>
        <li>Select a project from the dropdown list above.</li>
        <li>Select a scenario from the dropdown that appears.</li>
        <li>
          From the toolbar at the right, create, update & delete obstacles &
          attack vectors. Obstacles require a name. Attack vectors require a
          name and a speed.
        </li>
        <li>
          Once an attack vector is selected, it can be <b>recalculated</b> by
          clicking the button at the bottom right. A red attack path is created
          that represents the most likely path the attack would take, given the
          obstacle & speed restraints.
        </li>
        <li>Have fun!</li>
      </ul>
    </Container>
  )
}
